var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_1898)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_821_1898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.551 56.5C108.551 57.8183 108.551 59.1837 108.504 60.502C108.504 61.2554 108.504 62.0558 108.456 62.8091C108.456 65.6341 108.362 68.4591 108.268 71.2841C108.127 76.6516 107.844 81.8779 107.468 87.0099C107.185 90.8708 105.867 94.4491 103.889 97.4625C101.253 101.465 97.3918 104.525 92.8718 106.22C90.9885 106.879 89.0581 107.303 86.9864 107.444C82.7489 107.774 78.4173 108.009 74.0385 108.197C72.3435 108.245 70.6485 108.339 68.9535 108.386C64.8573 108.527 60.7139 108.574 56.5235 108.574H55.0168C45.0352 108.527 35.3831 108.15 26.0135 107.444C15.1373 106.644 6.37976 97.8862 5.57934 87.0099C4.82601 77.1695 4.44934 66.9525 4.44934 56.5C4.44934 46.2358 4.82601 36.207 5.53226 26.5549C6.33267 15.2549 15.2314 6.30911 26.5785 5.5087C36.2306 4.80245 46.2593 4.42578 56.5235 4.42578C66.976 4.42578 77.146 4.80245 86.9864 5.55578C97.9098 6.3562 106.62 15.1137 107.468 25.9899C108.174 35.8304 108.551 46.0475 108.551 56.5Z",
    fill: "url(#paint0_linear_821_1898)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.889 97.4625C101.253 101.465 97.3919 104.525 92.8719 106.22C90.9886 106.879 89.0582 107.303 86.9865 107.444C82.749 107.774 78.4173 108.009 74.0386 108.197C72.3436 108.245 70.6486 108.339 68.9536 108.386C64.8573 108.527 60.714 108.574 56.5236 108.574H55.0169L39.5265 89.882H39.4794L38.7261 88.9404L66.7877 74.8154L79.6415 68.3179L80.3948 69.2125L103.889 97.4625Z",
    fill: "url(#paint1_linear_821_1898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.268 71.2841C108.127 76.6516 107.844 81.8778 107.468 87.0099C107.185 90.8707 105.867 94.4491 103.889 97.4624C101.253 101.464 97.3919 104.525 92.8719 106.22L77.2402 87.3866L66.7877 74.8153L53.9811 59.4191L48.3311 52.592V52.5449L70.9781 26.602L71.0723 26.5078L108.268 71.2841Z",
    fill: "url(#paint2_linear_821_1898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 19.0498C46.6973 19.0498 38.7261 27.021 38.7261 36.8238C38.7261 46.4476 46.2406 54.2399 56.0574 54.5553C56.3399 54.5318 56.646 54.5271 56.8955 54.5553C56.9567 54.5601 57.0179 54.5648 57.0792 54.5648H57.1404C66.7124 54.2446 74.241 46.457 74.2787 36.8285C74.2787 27.0257 66.3075 19.0545 56.5047 19.0545L56.5 19.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5075 64.5419C65.0645 57.5689 48.0156 57.5594 37.4972 64.5419C37.4972 64.5419 37.4972 64.5419 37.4925 64.5419C32.7606 67.7106 30.1569 71.9999 30.1663 76.6282C30.171 81.2424 32.7747 85.5128 37.4972 88.6533C42.7375 92.161 49.6211 93.9125 56.5047 93.9125C63.3883 93.9125 70.2719 92.161 75.5122 88.6533C80.2441 85.4846 82.8478 81.1906 82.8384 76.567C82.8337 71.9528 80.23 67.6824 75.5075 64.5419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_821_1898",
    x: 0.449341,
    y: 4.42578,
    width: 112.101,
    height: 112.148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_821_1898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_821_1898",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_821_1898",
    x1: -2.06228,
    y1: -2.07172,
    x2: 112.958,
    y2: 112.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#117575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4290A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_821_1898",
    x1: 47.0457,
    y1: 63.1575,
    x2: 92.241,
    y2: 119.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3B3280",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#3B3280",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#3B3280",
    stopOpacity: 0.104
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3280",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_821_1898",
    x1: 25.6698,
    y1: 1.38414,
    x2: 92.1562,
    y2: 78.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#3B3280",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#3B3280",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#3B3280",
    stopOpacity: 0.104
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3280",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_1898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.e97473f5696221068e2c2900f53af72a.svg";
export { ForwardRef as ReactComponent };